import { Settings } from "lucide-react";
import { PipelinesSection } from "./settings/PipelinesSection";
import { LossReasonsSection } from "./settings/LossReasonsSection";
import { DealSourcesSection } from "./settings/DealSourcesSection";
import { ProspectingSection } from "./settings/ProspectingSection";

export default function CrmSettingsPanel() {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center">
          <Settings className="h-5 w-5" />
        </div>
        <div>
          <h2 className="text-lg font-semibold">Configurações do CRM</h2>
          <p className="text-sm text-muted-foreground">
            Funis, estágios, motivos de perda, origens do lead e fila de prospecção.
          </p>
        </div>
      </div>
      <PipelinesSection />
      <LossReasonsSection />
      <DealSourcesSection />
      <ProspectingSection />
    </div>
  );
}
